<div class="sir-image-container">
    @if (resolvedImage(); as img) {
        <sirius-image-item [image]="img" [imageData]="imageData()" [autocrop]="true"></sirius-image-item>
    }
    @if (resolvedAttributes(); as cardAttributes) {
        @if (cardAttributes.length) {
            <div class="sir-attr">
                @for (attr of cardAttributes; track attr.text) {
                    <sirius-chip [config]="attr"></sirius-chip>
                }
            </div>
        }
    }
</div>
<div class="sir-content">
    <div class="sir-text">
        <a [siriusLink]="resolvedLink()" class="sir-card__link" (linkSelect)="onClick()">
            <sirius-heading [text]="resolvedTitle()" textStyleSize="m" [h]="3"></sirius-heading>
        </a>
        <sirius-text-html
            class="sir-teaser"
            [html]="resolvedTeaserHtml()"
            textStyleSize="m"
            [lineClamp]="4"
        ></sirius-text-html>
    </div>
    @if (resolvedHighlights(); as productProperties) {
        @if (productProperties.length) {
            <sirius-highlight
                class="sir-product-properties"
                [highlights]="productProperties"
                size="s"
            ></sirius-highlight>
        }
    }
    @if (resolvedTags(); as cardTags) {
        @if (cardTags.length > 0) {
            <div class="sir-tags">
                @for (tag of cardTags; track tag.text) {
                    <sirius-chip [config]="tag"></sirius-chip>
                }
            </div>
        }
    }
</div>
